import { useCallback, useEffect, useRef, useState } from 'react';
import type { SportType } from '@/types';

/**
 * Random placeholder slot, optional regenerate pulse after chip inserts, and textarea focus helpers.
 */
export function usePromptRegenerationHints(segmentsLength: number, sport: SportType, setPrompts: React.Dispatch<React.SetStateAction<{ bike: string; run: string }>>) {
  const promptTextareaRef = useRef<HTMLTextAreaElement>(null);
  const [placeholderHintIndex] = useState(() => Math.floor(Math.random() * 4));
  const [regenerateHintPulse, setRegenerateHintPulse] = useState(false);

  useEffect(() => {
    if (segmentsLength === 0) {
      setRegenerateHintPulse(false);
    }
  }, [segmentsLength]);

  const handleChipSelect = useCallback(
    (chipText: string) => {
      const addition = chipText.trim();
      if (!addition) return;
      setPrompts((p) => {
        const existing = (p[sport] ?? '').trimEnd();
        const next = existing.length === 0 ? addition : `${existing} + ${addition}`;
        return { ...p, [sport]: next };
      });
      setRegenerateHintPulse(true);
      requestAnimationFrame(() => {
        const el = promptTextareaRef.current;
        if (!el) return;
        el.focus();
        const len = el.value.length;
        el.setSelectionRange(len, len);
      });
    },
    [sport, setPrompts],
  );

  return {
    promptTextareaRef,
    placeholderHintIndex,
    regenerateHintPulse,
    setRegenerateHintPulse,
    handleChipSelect,
  };
}
